import { render, staticRenderFns } from "./Savannah.vue?vue&type=template&id=d6976580&scoped=true&"
import script from "./Savannah.vue?vue&type=script&lang=js&"
export * from "./Savannah.vue?vue&type=script&lang=js&"
import style0 from "./Savannah.vue?vue&type=style&index=0&id=d6976580&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6976580",
  null
  
)

export default component.exports